import { Card, Grid, Group, Stack, Text } from "@mantine/core";
import { useState } from "react";

import TumblingEChartView from "@components/testContainer/progress/customProgressContainers/VAcuity/TumblingEChartView";
import TumblingEMetricsCard from "./TumblingEMetricsCard";
import { TumblingEResultData } from "types/testTypes";
import { usePrintableContext } from "@components";
import {
  getDisplayValuesFromSnellenSize,
  getSnellenStringFromSize,
  getVisualAcuityLabelByNotation,
  VisualAcuityNotation,
} from "@utils/test-specific-utils/VisualAcuityUtils";
import { useTranslation } from "react-i18next";
import VisualAcuityNotationSelector from "@components/testContainer/common/VisualAcuityNotationSelector";

interface TumblingETestEntryProps {
  result: TumblingEResultData;
}

export default function TumblingETestEntry({ result }: TumblingETestEntryProps) {
  const { t } = useTranslation();
  const { prettier } = usePrintableContext();
  const [notation, setNotation] = useState<VisualAcuityNotation>(
    VisualAcuityNotation.SnellenDecimal,
  );
  const thresholdSnellenLabel = getSnellenStringFromSize(result?.thresholdSnellenSize);
  const thresholdDisplayValues = getDisplayValuesFromSnellenSize(result?.thresholdSnellenSize);
  const thresholdSelectedLabel = getVisualAcuityLabelByNotation(thresholdDisplayValues, notation);
  const thresholdLabel =
    thresholdSnellenLabel &&
    thresholdSelectedLabel &&
    thresholdSelectedLabel !== thresholdSnellenLabel
      ? `${thresholdSnellenLabel} (${thresholdSelectedLabel})`
      : (thresholdSnellenLabel ?? thresholdSelectedLabel);
  const hasThresholdRow = result?.thresholdRow !== undefined && result?.thresholdRow !== null;

  return (
    <Card withBorder={prettier} radius="md" shadow={prettier ? "md" : "none"} py="xl">
      <Grid gutter="md">
        <Grid.Col span={2}>
          <TumblingEMetricsCard metrics={result?.metrics} />
        </Grid.Col>
        <Grid.Col span={10}>
          <Stack gap="sm">
            {hasThresholdRow ? (
              <div>
                <Text fw={700}>
                  {t("TumblingE.threshold.title")}: {thresholdLabel}
                </Text>
                <Text size="sm" c="dimmed">
                  {t("TumblingE.threshold.row")}: {(result.thresholdRow as number) + 1}
                </Text>
              </div>
            ) : null}
            <TumblingEChartView
              esOfInterestIds={result?.responses ?? []}
              thresholdRow={result?.thresholdRow}
              assumeLargerRowsCorrect={hasThresholdRow}
              notation={notation}
              baseChart={result?.chartStimuli}
            />
            <Group justify="center" className="no-print print-hide">
              <VisualAcuityNotationSelector value={notation} onChange={setNotation} />
            </Group>
          </Stack>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
